export default __webpack_public_path__ + "static/media/gift-card.fd24a214.png";